// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/colors.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[6].use[2]!../../../node_modules/ui-connect/styles/variables.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Privacy_optionContainer__hHtKp {
    align-items: center;
    border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_3"]};
    display: grid;
    font-size: 14px;
    grid-gap: 8px;
    grid-template-columns: minmax(auto, 270px);
    padding: 16px 0;
}
.Privacy_optionContainer__hHtKp:last-of-type {
    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_3"]};
}
.Privacy_optionTitleContainer__89Nuf {
    grid-column: 1/-1;
}
.Privacy_cancelButtonWrapper__1fK0X {
    margin-right: 16px;
}
.Privacy_removeCustomPrivacyHeader__wa7DX {
    font-weight: bold;
}
.Privacy_selectInput__m8i\\+A {
    width: 100%;
}
.Privacy_helpIcon__h-WkE {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_primary"]};
    margin: 5px 0 0 5px;
    font-size: 16px;
    cursor: pointer;
}
.Privacy_helpListContainer__IIzpR {
    margin: 11px 0 22px 25px;
}

@media (min-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["startSM"]}) {
    .Privacy_optionContainer__hHtKp {
        grid-template-columns: 25% minmax(auto, 270px);
        text-align: right;
    }
    .Privacy_optionTitleContainer__89Nuf {
        grid-column: initial;
    }
}

@media (min-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["startLG"]}) {
    .Privacy_optionContainer__hHtKp {
        grid-template-columns: 33% minmax(auto, 270px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/Privacy/Components/Privacy.module.css"],"names":[],"mappings":"AAGA;IACI,mBAAmB;IACnB,kEAAuC;IACvC,aAAa;IACb,eAAe;IACf,aAAa;IACb,0CAA0C;IAC1C,eAAe;AACnB;AACA;IACI,qEAA0C;AAC9C;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,WAAW;AACf;AACA;IACI,mDAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,8CAA8C;QAC9C,iBAAiB;IACrB;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,8CAA8C;IAClD;AACJ","sourcesContent":["@value (color_106, lightui_surface_3, blue_dark_1, black, blue_primary) from 'ui-connect/styles/colors.module.css';\n@value (startSM, startLG) from 'ui-connect/styles/variables.module.css';\n\n.optionContainer {\n    align-items: center;\n    border-top: 1px solid lightui_surface_3;\n    display: grid;\n    font-size: 14px;\n    grid-gap: 8px;\n    grid-template-columns: minmax(auto, 270px);\n    padding: 16px 0;\n}\n.optionContainer:last-of-type {\n    border-bottom: 1px solid lightui_surface_3;\n}\n.optionTitleContainer {\n    grid-column: 1/-1;\n}\n.cancelButtonWrapper {\n    margin-right: 16px;\n}\n.removeCustomPrivacyHeader {\n    font-weight: bold;\n}\n.selectInput {\n    width: 100%;\n}\n.helpIcon {\n    color: blue_primary;\n    margin: 5px 0 0 5px;\n    font-size: 16px;\n    cursor: pointer;\n}\n.helpListContainer {\n    margin: 11px 0 22px 25px;\n}\n\n@media (min-width: startSM) {\n    .optionContainer {\n        grid-template-columns: 25% minmax(auto, 270px);\n        text-align: right;\n    }\n    .optionTitleContainer {\n        grid-column: initial;\n    }\n}\n\n@media (min-width: startLG) {\n    .optionContainer {\n        grid-template-columns: 33% minmax(auto, 270px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color_106": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color_106"]}`,
	"lightui_surface_3": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["lightui_surface_3"]}`,
	"blue_dark_1": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_dark_1"]}`,
	"black": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["black"]}`,
	"blue_primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["blue_primary"]}`,
	"startSM": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["startSM"]}`,
	"startLG": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["startLG"]}`,
	"optionContainer": `Privacy_optionContainer__hHtKp`,
	"optionTitleContainer": `Privacy_optionTitleContainer__89Nuf`,
	"cancelButtonWrapper": `Privacy_cancelButtonWrapper__1fK0X`,
	"removeCustomPrivacyHeader": `Privacy_removeCustomPrivacyHeader__wa7DX`,
	"selectInput": `Privacy_selectInput__m8i+A`,
	"helpIcon": `Privacy_helpIcon__h-WkE`,
	"helpListContainer": `Privacy_helpListContainer__IIzpR`
};
export default ___CSS_LOADER_EXPORT___;
